import type { WorktreeBaseBranches } from '@buildautomaton/types';

export function resolveBaseRefForRepo(
  repoPathRelativeToBridgeRoot: string,
  baseBranches: WorktreeBaseBranches | undefined,
): string {
  if (!baseBranches) return 'HEAD';
  const direct = baseBranches[repoPathRelativeToBridgeRoot]?.trim();
  if (direct) return direct;
  if (repoPathRelativeToBridgeRoot !== '.' && baseBranches['.']?.trim()) {
    return baseBranches['.'].trim();
  }
  return 'HEAD';
}
